<template>
    <div>
        <input
            v-model.number="localValue"
            @change="onChange"
            @input="localValue = numberInput($event.target.value);"
            type="number"
            :disabled="isDisabled"
            style="width: 75px"
        />
    </div>
</template>
<script>
export default {
    props: {
        value: {
            type: Number,
            required: true
        },
        itemId: {
            type: Number,
            required: true
        },
        recurrence: {
            type: Number,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        isDisabled: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            localValue: 0
        };
    },
    created() {
        this.localValue = this.value;
    },
    methods: {
        onChange() {
            if (this.localValue !== this.value) {
                this.$emit("update", { value: this.localValue, itemId: this.itemId, recurrence: this.recurrence, index: this.index });
            }
        },
        numberInput(input) {
            if (input === "") {
                return 0;
            }
            input = parseInt(input);
            return input < 0 ? 0 : input;
        }
    }
};
</script>
<style scoped lang="scss">
input {
    border: thin solid grey;
    border-radius: 3px;
    padding: 2px 3px;
}
</style>



// WEBPACK FOOTER //
// QuantityInput.vue?37adface